export var globalLeadSource = getUrlLeadSource();
function getUrlLeadSource() {
    if (typeof window === 'undefined')
        return;
    try {
        var url = new URL(window.location.href);
        return url.searchParams.get('lead_source');
    }
    catch (error) {
        console.error(error);
    }
}
